import { CustomizedButton } from '@components/Customized';
import { ICustomizedButtonProps } from '@components/Customized/types';
import { colorSet } from '@components/Provider';
import styled, { css } from 'styled-components';

export const CompanyInfoSection = styled.div`
  ${({ theme }) => `position: relative;
width: 100%;
padding: 26px 0px;
display: flex;
flex-direction: column;
row-gap: 8px;
border-bottom: 1px solid ${colorSet.gray200};

${theme.breakpoints.down('xs')} {
  padding : 24.5px 16px;
  border-bottom : 16px solid ${colorSet.gray200};
}

:last-child {
  border-bottom: none;
}
.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  > p {
    font-size: 18px;
    font-weight: 700;
    color: ${colorSet.gray900};
  }
  .new-column {
    > p {
      font-size: 18px;
      font-weight: 700;
      color: ${colorSet.gray900};
    }
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
.no-data {
  font-size: 14px;
  color: ${colorSet.gray700};
}

`}
`;

export const CompanyInfoDetailSection = styled.div`
  ${({ theme }) => css`
    width: 100%;
    padding: 18px 0px;
    display: flex;
    column-gap: 10px;
    border-bottom: 1px solid ${colorSet.gray200};
    align-items: center;
    justify-content: space-between;
    p {
      font-size: 14px;
    }
    :last-child {
      border-bottom: none;
    }
    .data-row {
      display: flex;
      gap: 10px;
      align-items: flex-start;
      .row-title {
        display: flex;
        align-items: center;
        gap: 6px;
        min-width: 88px;
      }
      .row-value {
        display: flex;
        align-items: flex-start;
        word-break: break-all;
        font-weight: 500;
      }
      .no-data {
        color: ${colorSet.gray700};
      }
    }
    ${theme.breakpoints.down('xs')} {
      padding: '16px 0px';
    }
  `}
`;

export const CompanyInfoEditButton = styled(
  (props: ICustomizedButtonProps & { updateType: 'edit' | 'add' }) => {
    const { updateType, ...rest } = props;
    return CustomizedButton({
      ...rest,
      size: undefined,
      variant: props.updateType === 'edit' ? 'contained' : 'outlined',
      color: props.updateType === 'edit' ? 'default' : 'primary'
    });
  }
)`
  &.medium {
    border-radius: 4px;
    min-width: 44px;
    width: 44px;
    height: 26px;
    span {
      white-space: nowrap;
      color: ${({ updateType }) =>
        updateType === 'edit' ? colorSet.gray900 : colorSet.primary500};
    }
  }
`;

export const DialogButtonGroup = styled('div')`
  width: 100%;
  display: flex;
  gap: 8px;
  button: {
    flex: 1;
  }
`;
